// ExportPanelDXF.tsx — Export active panel to DXF R2000

import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';
import { buildPanelDXFString, panelDXFFilename } from '../utils/dxfExport';
import { gatedDownload } from '../utils/exportGateway';
import { useEntitlement } from '../auth/AuthProvider';

const encoder = new TextEncoder();

export default function ExportPanelDXF() {
  const { ui, project } = useShallowStore(s => ({ ui: s.ui, project: s.project }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const { refresh } = useEntitlement();

  async function handleExport() {
    if (!panel) return;
    const res = await gatedDownload({
      artifact: 'dxf',
      filename: panelDXFFilename(panel),
      mimeType: 'application/dxf',
      preflight: () => {
        const { width, height, panelMark } = panel.mpvar;
        if (!width || !height || width <= 0 || height <= 0) {
          throw new Error(`Cannot export DXF: panel "${panelMark || 'unnamed'}" has invalid dimensions.`);
        }
      },
      build: () => encoder.encode(buildPanelDXFString(panel)),
    });
    if (res.ok) {
      refresh();
    } else if (res.reason === 'preflight') {
      alert(res.message ?? 'Cannot export DXF: invalid panel.');
    } else if (res.reason === 'producer_error') {
      alert(res.message ?? 'DXF export failed.');
    } else if (res.reason === 'network') {
      alert(`Export failed: ${res.message ?? 'network error'}`);
    }
  }

  return (
    <DialogBase
      title="Export Panel DXF"
      okLabel="Export"
      onOk={() => { void handleExport(); }}
    >
      {panel ? (
        <>
          <p className="dialog-info">
            Exporting panel <strong>{panel.mpvar.panelMark}</strong> as DXF R2000.
          </p>
          <p className="dialog-info">
            Layers: PANEL, OPENINGS, BLOCKOUTS, FEATURES, STRUCTURAL, DIMENSIONS, NOTES, REVISIONS
          </p>
          <p className="dialog-info">
            The .dxf file can be opened directly in AutoCAD or converted to .dwg.
          </p>
          <p className="dialog-info">
            <em>Costs 1 token.</em>
          </p>
        </>
      ) : (
        <p className="dialog-warning">No panel selected. Please select a panel first.</p>
      )}
    </DialogBase>
  );
}
